/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Task_ValueInputs */

const en_how_we_work_brief_task_value = /** @type {(inputs: How_We_Work_Brief_Task_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare replies to new enquiries`)
};

const lv_how_we_work_brief_task_value = /** @type {(inputs: How_We_Work_Brief_Task_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavot atbildes uz jauniem pieprasījumiem`)
};

/**
* | output |
* | --- |
* | "Prepare replies to new enquiries" |
*
* @param {How_We_Work_Brief_Task_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_task_value = /** @type {((inputs?: How_We_Work_Brief_Task_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Task_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_task_value(inputs)
	return en_how_we_work_brief_task_value(inputs)
});